import { Box, Flex } from '@rebass/grid'
import * as React from 'react'
import { connect } from 'react-redux'
import { Hr, Text } from 'src/elements'
import { Dispatch, RootState, store } from 'src/store'
import styled from 'styled-components'
import Icon from '../Icon'
import Reply from '../Reply'
import DiscussionInput from './DiscussionInput'

type IMaterialDiscussionProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>

const OverlayContainer = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center'
})`
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 999;
  @media (max-width: 576px) {
    align-items: flex-end;
  }
`

const DialogContainer = styled(Flex).attrs({
  flexDirection: 'column',
  flex: 1
})`
  max-width: 564px;
  border-radius: 8px;
  box-shadow: 0 -2px 16px 0 rgba(0, 0, 0, 0.2);
  background-color: white;
`

const DialogHeaderContainer = styled(Flex).attrs({
  justifyContent: 'space-between'
})`
  height: 48px;
  padding: 12px;
`

const DiscussionAreaContainer = styled(Flex).attrs({ flexDirection: 'column' })`
  flex: 1;
  overflow-y: scroll;
  padding-left: 24px;
  padding-right: 40px;
  padding-top: 24px;
  height: 60vh;
`

const ReplyAreaContainer = styled(Flex)`
  padding: 20px 32px;
  align-items: center;
`

const Button = styled.button`
  background: #ff730e;
  color: #fff;
  font-size: 16px;
  line-height: 24px;
  padding: 10px 21px;
  border: 0;
  border-radius: 4px;

  &:hover {
    background: #ff8e1e;
  }

  &:active {
    background: #ec6d11;
  }

  &:disabled {
    background-color: #ececec;
  }
`

const MaterialDiscussion = ({
  currentReplyId,
  isAuthenticated,
  replyIds,
  onClose,
  onReply,
  onReplyReset,
  onReplyLike,
  onReplyEdit,
  onReplyChange,
  isInsightLoading,
  isReplyAdding,
  currentLecture,
  onAuthModalOpen
}: IMaterialDiscussionProps) => {
  return (
    <OverlayContainer>
      <DialogContainer>
        <DialogHeaderContainer>
          <Box>
            <Text.SubtitleBold>討論</Text.SubtitleBold>
          </Box>
          <Box>
            <Icon
              type="popup-close"
              onClick={onClose}
              style={{ cursor: 'pointer' }}
            />
          </Box>
        </DialogHeaderContainer>
        <Hr />

        {isInsightLoading ? (
          <Flex py={56} justifyContent="center">
            <Text.Content>討論串載入中...</Text.Content>
          </Flex>
        ) : replyIds.length ? (
          <DiscussionAreaContainer>
            {replyIds.map(replyId => (
              <Box key={replyId} mb={24}>
                <Reply
                  replyId={replyId}
                  onLike={onReplyLike.bind(null, replyId)}
                  onEdit={onReplyEdit.bind(null, replyId)}
                  onReply={onReplyChange.bind(null, replyId)}
                />
              </Box>
            ))}
          </DiscussionAreaContainer>
        ) : (
          <Flex py={56} justifyContent="center">
            <Text.Content>留下你的想法與講師討論</Text.Content>
          </Flex>
        )}
        <Hr />
        {/* <Flex>
          <Box>正在回覆：{currentReplyId}</Box>
          <Box>
            <Button onClick={onReplyReset}>發表留言</Button>
          </Box>
        </Flex> */}
        {isAuthenticated ? (
          <ReplyAreaContainer>
            <Box mr={2} flex={1} css={{ height: '44px' }}>
              <DiscussionInput />
            </Box>
            <Box>
              <Button disabled={isReplyAdding} onClick={onReply}>
                送出
              </Button>
            </Box>
          </ReplyAreaContainer>
        ) : (
          <ReplyAreaContainer>
            <Text.ContentMain onClick={onAuthModalOpen}>登入</Text.ContentMain>
            <Text.Content>後才可討論</Text.Content>
          </ReplyAreaContainer>
        )}
      </DialogContainer>
    </OverlayContainer>
  )
}

const mapState = ({
  auth,
  discussion,
  insights,
  loading,
  lectures,
  lectureContent
}: RootState) => {
  const insight = discussion.insightId ? insights[discussion.insightId] : null
  return {
    currentReplyId: discussion.replyId,
    replyIds: insight ? insight.materials[discussion.materialIdx].replyIds : [],
    isInsightLoading: !insight,
    isReplyAdding: loading.effects.discussion.addReply,
    isAuthenticated: auth.isAuthenticated,
    currentLecture:
      lectureContent.currentLectureId &&
      lectures[lectureContent.currentLectureId]
        ? lectures[lectureContent.currentLectureId]
        : null
  }
}

const mapDispatch = (dispatch: Dispatch) => {
  return {
    onClose: () => dispatch.discussion.closeDiscussion(),
    onReply: () => dispatch.discussion.addReply(),
    onReplyReset: () =>
      dispatch.discussion.changeCurrentReplyId({ replyId: null }),
    onReplyChange: (replyId: string) =>
      dispatch.discussion.changeCurrentReplyId({ replyId }),
    onReplyLike: (replyId: string) => {
      const { discussion, lectureContent } = store.getState()
      const { chapterIdx, insightId, materialIdx } = discussion
      dispatch.replies
        .toggleReaction({
          lectureId: lectureContent.currentLectureId || '',
          chapterIdx,
          insightId: insightId || '',
          materialIdx,
          replyId,
          reaction: 'like'
        })
        .catch(err => alert(err.message))
    },
    onReplyEdit: (replyId: string, text: string) => {
      dispatch.replies.updateReply({
        replyId,
        updated: {
          text
        }
      })
    },
    onAuthModalOpen: () => dispatch.auth.openAuthModal()
  }
}

export default connect(
  mapState,
  mapDispatch
)(MaterialDiscussion)



// WEBPACK FOOTER //
// ./src/components/MaterialDiscussion/index.tsx